<template>
    <v-container fluid>
        <v-row>
            <v-col sm="12">
                <v-card>
                    <benutzer-liste :benutzer-list="treuhandBenutzerData" />
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-facing-decorator';
import { namespace } from 'vuex-facing-decorator';

import { NAME as NAME_TREUHANDADMINISTRATION } from '../store';
import { NAME as NAME_GENERAL } from '@/store/modules/general';
import { NAME as NAME_SECURITY } from '@/store/modules/security';
import { NAME as NAME_HEADERNOTIFICATION } from '@/store/modules/headerNotification';

const treuhandAdministrationModul = namespace(NAME_TREUHANDADMINISTRATION);
const generalModul = namespace(NAME_GENERAL);
const securityModul = namespace(NAME_SECURITY);
const headerModul = namespace(NAME_HEADERNOTIFICATION);

import { HASACCESS } from '@/store/modules/security/getters';
import { SETACCESSDENIED } from '@/store/modules/security/mutations';
import { NEW_ALERT } from '@/store/modules/headerNotification/actions';
import { GETTREUHANDBENUTZERDATA } from '../store/getters';
import { SUBTITLE, FOOTERTITLE } from '@/store/modules/general/mutations';
import TreuhandBenutzerListe from './TreuhandBenutzerListe.vue';
import { TeilnehmerBenutzerDto } from '@/types/UserDtos';
import { GET_BENUTZER_BY_ID } from '@/areas/treuhandadministration/store/actions';
@Component({
    components: {
        BenutzerListe: TreuhandBenutzerListe
    }
})
export default class TreuhandEinstellungen extends Vue {
    @generalModul.Mutation(FOOTERTITLE) setFooterTitle!: Function;
    @generalModul.Mutation(SUBTITLE) setSubTitle!: Function;
    @securityModul.Getter(HASACCESS) hasAccess!: Function;
    @securityModul.Mutation(SETACCESSDENIED) setAccessDenied!: Function;
    @headerModul.Action(NEW_ALERT) alertMessage!: Function;
    @treuhandAdministrationModul.Getter(GETTREUHANDBENUTZERDATA) treuhandBenutzerData!: Array<TeilnehmerBenutzerDto>;
    @treuhandAdministrationModul.Action(GET_BENUTZER_BY_ID) getBenutzer!: Function;

    mounted() {
        this.setSubTitle(this.$t('treuhand.einstellungen.subtitle'));
        this.setFooterTitle('S620');
        if (!this.hasAccess('Navigation.TreuhandEinstellungen')) {
            this.setAccessDenied(true);
            this.alertMessage({ text: this.$t('errormessage.noaccesspage') });
        } else {
            this.setAccessDenied(false);
            this.getBenutzer();
        }
    }
}
</script>
